import React from 'react';

import { Container } from './ContentText.styles';

type Props = {
  children: React.ReactNode;
  offset: string;
};

export default (props: Props) => <Container {...props}>{props.children}</Container>;
